import WaysToUseWithCTA from '@/src/modules/pg-plus/content/WaysToUseWithCTA'
import BrandDescription from '@/src/modules/pg-plus/content/BrandDescription'
import { styled } from '@/src/stitches.config'
import {
    TMinMaxFromGYPMerchant,
    TPGPlusEnabledRedemptionOptions,
} from '@/src/modules/build-a-card/types'
import determineValidDenomText from '@/src/common/utilities/determineValidDenomText'
import GiftIdeasAndRecommendations from '@/src/modules/pg-plus/content/recommendations/GiftIdeasAndRecommendations'
import { PG_PLUS_NAME } from '@/prisma/schemaConstants'
import { TPartnerPayload } from '../../partners/types'
import isEmpty from 'lodash/isEmpty'

const Wrapper = styled('div', {
    variants: {
        variant: {
            mobile: {
                width: '$default',
                maxWidth: '$defaultMax',
                margin: 'auto',
                pb: 30,
            },
        },
    },
})

type TDescriptionProps = {
    adjustedBrandName: string
    description: any
    minMaxAndFixed: TMinMaxFromGYPMerchant
    redemptionOptions: TPGPlusEnabledRedemptionOptions
    trendingItems: [] | null
    currentStep: number
    startOpen: boolean
    partnerData?: TPartnerPayload
}

const BrandDescriptionWithOptionalCTA = ({
    adjustedBrandName,
    description,
    minMaxAndFixed,
    redemptionOptions,
    trendingItems,
    partnerData,
    currentStep,
    startOpen,
}: TDescriptionProps) => {
    const openDescription: boolean =
        startOpen && currentStep < 2 && isEmpty(partnerData)
    const hideGiftIdeasAndRecommendations = true //hide these for partner sites
    const hasPartnerStorePage =
        !!partnerData?.programConfig?.store_page_brand_id

    return (
        <Wrapper variant={startOpen ? undefined : 'mobile'}>
            <WaysToUseWithCTA
                brandName={adjustedBrandName}
                validEGiftDenoms={determineValidDenomText(minMaxAndFixed)}
                redemptionOptions={redemptionOptions}
                isPgPlus={adjustedBrandName === PG_PLUS_NAME}
                hasPartner={!!partnerData}
                showStonlyHelpBubble={
                    partnerData?.programConfig?.show_stonly_help_bubble ?? false
                }
            />
            {/*only show this section if not in partner flow*/}
            {/*OR trending items are available*/}
            {!hasPartnerStorePage &&
                !hideGiftIdeasAndRecommendations &&
                (trendingItems || isEmpty(partnerData)) && (
                    <GiftIdeasAndRecommendations
                        image1={
                            'https://res.cloudinary.com/gift-card-granny/image/upload/w_200,f_auto/PGSite/product_images/visa_virtual_uncropped_qtot9a.png'
                        }
                        image2={
                            'https://res.cloudinary.com/gift-card-granny/image/upload/v1712343748/PGSite/marketing_images/bac-custom-image_afrjqm.png'
                        }
                        trendingItems={trendingItems}
                        hasPartner={!!partnerData}
                    />
                )}

            <BrandDescription
                brandName={adjustedBrandName}
                description={description}
                startOpen={openDescription}
            />
        </Wrapper>
    )
}

export default BrandDescriptionWithOptionalCTA
